export default "__VITE_ASSET__4e3ecc98__"